import { useTranslation } from 'react-i18next'

import { MascotSlot } from '@/components/ui-kit/Mascot'
import { Headline } from '@/components/ui-kit/Primitives'
import { ScreenShell, TopBar } from '@/components/ui-kit/Shell'
import { HELP_LINKS, FACT_KEYS } from '@/content/facts'

/**
 * Fakten und Hilfeangebote.
 *
 * Öffnet sich auf den Handys automatisch, sobald die Lehrkraft die letzte
 * Auswertungsstufe erreicht. Die Hilfe-Links sind der eigentliche Zweck der
 * Stunde und stehen deshalb hier und nicht in einem Untermenü.
 */
export function FactsScreen() {
    const { t } = useTranslation()

    return (
        <ScreenShell>
            <TopBar title={t('facts.title')} />

            <div className="wb-scroll flex flex-1 flex-col gap-4 overflow-y-auto pt-3">
                <div className="flex items-center gap-3">
                    <MascotSlot pose="lecturing" size={72} />
                    <Headline className="text-xl">{t('facts.headline')}</Headline>
                </div>

                <ul className="flex flex-col gap-2">
                    {FACT_KEYS.map((key) => (
                        <li
                            key={key}
                            className="rounded-2xl border border-wb-border bg-wb-panel p-3.5"
                        >
                            <h3 className="text-sm font-extrabold text-wb-accent">
                                {t(`facts.items.${key}.title`)}
                            </h3>
                            <p className="mt-1 text-[13px] leading-snug text-wb-dim">
                                {t(`facts.items.${key}.body`)}
                            </p>
                        </li>
                    ))}
                </ul>

                <section className="rounded-2xl border border-wb-win/40 bg-wb-win/5 p-4">
                    <h3 className="text-sm font-extrabold text-wb-win">{t('facts.helpTitle')}</h3>
                    <p className="mt-1 text-[13px] text-wb-dim">{t('facts.helpBody')}</p>

                    <ul className="mt-3 flex flex-col gap-2">
                        {HELP_LINKS.map((link) => (
                            <li
                                key={link.key}
                                className="rounded-xl border border-wb-border bg-wb-panel px-3 py-2.5"
                            >
                                <div className="text-[13px] font-bold">
                                    {t(`facts.links.${link.key}.name`)}
                                </div>
                                <a
                                    href={link.href}
                                    target="_blank"
                                    rel="noreferrer noopener"
                                    className="mt-0.5 block wb-num text-xs font-bold text-wb-accent underline"
                                >
                                    {t(`facts.links.${link.key}.url`)}
                                </a>
                                <div className="mt-0.5 text-[11px] text-wb-muted">
                                    {t(`facts.links.${link.key}.desc`)}
                                </div>
                            </li>
                        ))}
                    </ul>
                </section>
            </div>
        </ScreenShell>
    )
}
